import * as React from "react";
import pluginRegistry from "../pluginRegistry";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import SpecialVariables from "client/specialVariables";
import {repository} from "clientInstance";
import Roles from "../Roles";
import {ActionSummaryProps} from "../actionSummaryProps";
import {ActionExecutionLocation} from "../../../client/resources/actionExecutionLocation";
import {TentaclePackageActionEdit} from "components/Actions/tentaclePackage/tentaclePackageAction";
import {getFeedName} from "../getFeedName";
import { TargetRoles } from "areas/projects/components/DeploymentProcess/ActionDetails";

interface IISActionSummaryState {
    feedName: string;
}

class IISActionSummary extends BaseComponent<ActionSummaryProps, IISActionSummaryState> {
    constructor(props: any) {
        super(props);
        this.state = {feedName: null };
    }

    async componentDidMount() {
        this.setState({feedName: await getFeedName(this.getFeedId())});
    }

    render() {
        return <div>
            Deploy to IIS using package <strong>{this.props.properties[SpecialVariables.Action.Package.PackageId]} </strong>
            from {this.state.feedName ? <strong>{this.state.feedName}</strong> : <em>{this.getFeedId()}</em>}
            {this.props.targetRolesAsCSV && <span> to deployment targets in <Roles rolesAsCSV={this.props.targetRolesAsCSV} /> </span>}
        </div>;
    }

    private getFeedId() {
        return this.props.properties[SpecialVariables.Action.Package.FeedId] as string;
    }
}

pluginRegistry.registerDeploymentAction({
    executionLocation: ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.IIS",
    summary: (properties, targetRolesAsCSV) => <IISActionSummary properties={properties} targetRolesAsCSV={targetRolesAsCSV} />,
    edit: TentaclePackageActionEdit,
    canHaveChildren: (step) => true,
    canBeChild: true,
    targetRoleOption: TargetRoles.Optional,
    hasPackages: (action) => true,
    features: {
        permanent: ["Octopus.Features.IISWebSite"],
        optional: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables", "Octopus.Features.CustomDirectory",
            "Octopus.Features.CustomScripts", "Octopus.Features.JsonConfigurationVariables", "Octopus.Features.SubstituteInFiles"],
        initial: ["Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables"]
    }
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/iis/iisAction.tsx